import outlet from "fragments/news/outlet"
import { gql } from "graphql-tag"

const ADD_OUTLET = gql`
  ${outlet}

  mutation addOutlet(
    $outletAddInput: OutletAddInput!
    $socialLinksAddInput: SocialLinksAddInput
  ) {
    addOutlet(
      outletAddInput: $outletAddInput
      socialLinksAddInput: $socialLinksAddInput
    ) {
      ...Outlet
    }
  }
`

export default ADD_OUTLET
